import {TableSummary} from "../../../../../domain/out/table-summary";
import {CustomGroup} from "../../../../../domain/in/quote/group/custom-group";
import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {AbstractPricingItemSummaryMapper} from "../abstract-pricing-item-summary.mapper";
import {FrCaIcsHbeSasSynthesisMapper} from "./sas/fr.ca-ics-hbe.sas.synthesis.mapper";
import {FrCaIcsHbeCafSynthesisMapper} from "./caf/fr.ca-ics-hbe.caf.synthesis.mapper";
import {FrCaIcsHbeFonSynthesisMapper} from "./fon/fr.ca-ics-hbe.fon.synthesis.mapper";
import {FrCaIcsHbeSolSynthesisMapper} from "./sol/fr.ca-ics-hbe.sol.synthesis.mapper.ts";
import {FrCaIcsHbeDasriSynthesisMapper} from "./dasri/fr.ca-ics-hbe.dasri.synthesis.mapper";
import {
    ContractViewSynthesisReorganizationService
} from "../../contract-view-synthesis-reorganization/contract-view-synthesis-reorganization.service";

export class TableSummaryCaIcsHbeMapper {
    private readonly mappers: Map<string, AbstractPricingItemSummaryMapper>;
    private contractViewSynthesisReorganizationService: ContractViewSynthesisReorganizationService;

    constructor(protected translationService: TranslationServiceInterface) {
        this.mappers = new Map<string, AbstractPricingItemSummaryMapper>([
            ['SAS', new FrCaIcsHbeSasSynthesisMapper(translationService)],
            ['FON', new FrCaIcsHbeFonSynthesisMapper(translationService)],
            ['CAF', new FrCaIcsHbeCafSynthesisMapper(translationService)],
            ['SOL', new FrCaIcsHbeSolSynthesisMapper(translationService)],
            ['DASRI', new FrCaIcsHbeDasriSynthesisMapper(translationService)],
        ]);
        this.contractViewSynthesisReorganizationService = new ContractViewSynthesisReorganizationService();
    }

    public async getTablesSummary(group: CustomGroup, serviceCode: string, currency: string, view: string, locale: string) {
        let tableSummaries: TableSummary[] = [];
        let tableSummary = new TableSummary();
        let pricingItems = group.pricingItems;
        if (view === 'contract') {
            pricingItems = this.contractViewSynthesisReorganizationService.getReorganizedPricingItems(group.pricingItems);
        }
        const mapper = this.mappers.get(serviceCode) ?? this.mappers.get('SAS')!;
        tableSummary.pricingItems = await Promise.all(pricingItems.map(pricingItem =>
            mapper.pricingItemToProductItemSummary(pricingItem, currency, locale)
        ));
        if (serviceCode === 'SOL') {
            tableSummary.pricingItems = tableSummary.pricingItems.sort((a, b) => a.family?.localeCompare(b.family));
        }
        tableSummaries.push(tableSummary);
        return tableSummaries;
    }

}